import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { I18nProvider } from "@/contexts/I18nContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/layout/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Animals from "@/pages/Animals";
import AnimalDetail from "@/pages/AnimalDetail";
import Feed from "@/pages/Feed";
import Weighings from "@/pages/Weighings";
import Milk from "@/pages/Milk";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

function PublicOnly({ children }) {
    const { user, ready } = useAuth();
    if (!ready) return null;
    if (user) return <Navigate to="/" replace />;
    return children;
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <I18nProvider>
                    <AuthProvider>
                        <Routes>
                            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
                            <Route path="/registro" element={<PublicOnly><Register /></PublicOnly>} />
                            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                                <Route index element={<Dashboard />} />
                                <Route path="/animales" element={<Animals />} />
                                <Route path="/animales/:id" element={<AnimalDetail />} />
                                <Route path="/alimento" element={<Feed />} />
                                <Route path="/pesajes" element={<Weighings />} />
                                <Route path="/leche" element={<Milk />} />
                                <Route path="/reportes" element={<Reports />} />
                                <Route path="/ajustes" element={<Settings />} />
                            </Route>
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </AuthProvider>
                </I18nProvider>
            </BrowserRouter>
        </div>
    );
}
